import React, { useEffect, useState } from "react";
import InputField from "../../../Component/InputField";
import api from "../../../Services/api";
import { Title } from "chart.js";

const UploadActsRules = ({ onClose, isEdit, triggerSnackbar }) => {
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [states, setStates] = useState([]);
  // const [actOrRulesOptions] = useState(["Act", "Rules"]); // dropdown options
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const [nameError, setNameError] = useState("");
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [existingFileUrl, setExistingFileUrl] = useState("");
  const [existingData, setExistingData] = useState(null);

  const isButtonDisabled = isEdit
    ? !isFormChanged || !title.trim() || !type.trim() || !selectedState
    : !title.trim() || !type.trim() || !selectedState;

  const resetForm = () => {
    setTitle("");
    setType("");
    setSelectedState("");
    setSelectedStateId("");
    setFile(null);
    setFileError("");
  };

  useEffect(() => {
    getAllStates();
    if (isEdit) {
      const original = {
        Title: isEdit.Title || "",
        Type: isEdit.Type || "",
        State: isEdit.State || "",
        StateId: isEdit.StateId || "",
        FileUrl: isEdit.FileUrl || "",
      };
      setTitle(original.Title);
      setType(original.Type);
      setSelectedState(original.State);
      setSelectedStateId(original.StateId);
      setExistingFileUrl(original.FileUrl);
      setExistingData(original);
      setIsFormChanged(false);
    } else {
      setExistingData(null);
    }
  }, [isEdit]);
  useEffect(() => {
    if (isEdit && existingData) {
      const hasChanged =
        title.trim() !== existingData.Title.trim() ||
        type.trim() !== existingData.Type.trim() ||
        selectedState.trim() !== existingData.State.trim() ||
        selectedStateId !== existingData.StateId ||
        existingFileUrl !== existingData.FileUrl;
      setIsFormChanged(hasChanged);
    }
  }, [
    title,
    type,
    selectedState,
    selectedStateId,
    existingFileUrl,
    isEdit,
    existingData,
  ]);

  const getAllStates = async () => {
    const res = await api.common.getAllStatesApi();
    console.log(res);
    setStates(res.data.states || []);
  };

  const handleSubmit = async () => {
    // if (!file && !isEdit) {
    //   setFileError("Please upload a file.");
    //   return;
    // }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("Title", title);
    formData.append("Type", type);
    formData.append("State", selectedState);
    formData.append("StateId", selectedStateId);

    try {
      if (isEdit) {
        const res = await api.ActsAndRules.editActAndRules(
          isEdit._id,
          formData
        );
        if (res.status === 200) {
          triggerSnackbar("success", res.data.message);
          resetForm();
          onClose();
        } else if (res.status === 404 || res.status === 500) {
          triggerSnackbar("error", res.data.message);
        }
      } else {
        const res = await api.ActsAndRules.createActAndRules(formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res.status === 201) {
          triggerSnackbar("success", res.data.message);
        } else if (res.status === 500) {
          triggerSnackbar("error", res.data.message);
        }
      }
      resetForm();
      onClose();
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    // Validate file type
    if (selectedFile.type !== "application/pdf") {
      setFileError("Only PDF files are allowed.");
      setFile(null);
      return;
    }

    // Validate file size (3MB max)
    const maxSize = 3 * 1024 * 1024; // 3MB in bytes
    if (selectedFile.size > maxSize) {
      setFileError("File size cannot exceed 3MB.");
      setFile(null);
      return;
    }

    // If valid
    setFile(selectedFile);
    setFileError("");
    setIsFormChanged(true);
  };

  const handleTextArea = (e) => {
    const value = e.target.value;

    if (value.length > 250) {
      setNameError("Should not exceed more than 250 characters");
    } else {
      setNameError(""); // clear error
      setTitle(value);
      setIsFormChanged(true);
    }
  };

  return (
    <div className="bg-[#F5F5F5] w-full  h-auto flex flex-col justify-between  overflow-y-auto">
      <div className="flex flex-col p-12 gap-16 w-full  justify-center item-center ">
        <h1 className="text-3xl leading-[120%] font-medium text-center">
          Upload Acts/Rules
        </h1>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Upload File Section */}

          <div className="flex flex-col gap-2 max-w-[512px]">
            <h1 className="font-semibold text-xs tracking-[2%] leading-[18px]">
              Upload File
            </h1>
            <div
              className={`w-[512px] h-[322px] rounded-2xl px-4 py-3 bg-white flex flex-col justify-center items-center gap-[10px] 
                ${isDragging ? "border-2 border-red-500" : "border-none"}`}
              onClick={() => document.getElementById("fileInput").click()}
              onDragOver={(e) => {
                e.preventDefault();
                setIsDragging(true);
              }}
              onDragLeave={(e) => {
                e.preventDefault();
                setIsDragging(false);
              }}
              onDrop={(e) => {
                e.preventDefault();
                setIsDragging(false);
                const droppedFile = e.dataTransfer.files[0];
                handleFileChange({ target: { files: [droppedFile] } });
              }}
            >
              <div className="w-10 h-10 rounded-full p-[10px] bg-[#F5E0DF]">
                <svg
                  width="22"
                  height="23"
                  viewBox="0 0 22 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 21.5V10.3889M11 10.3889L14.3333 13.7222M11 10.3889L7.66667 13.7222M16.5556 16.8538C19.1152 16.1749 21 13.8607 21 11.1103C21 8.38898 19 5.875 16 5.38889C15.059 3.15152 12.8318 1.5 10.2341 1.5C6.90667 1.5 4.187 4.08057 4 7.33333C2.23411 8.10542 1 10.0003 1 12.0521C1 14.6276 2.94444 16.7484 5.44444 17.025"
                    stroke="#CD2224"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-col justify-center items-center gap-2">
                {file ? (
                  <h1 className="font-medium text-[13px] leading-[19px] tracking-[2%] text-[#00000066]">
                    {file.name}
                  </h1>
                ) : existingFileUrl ? (
                  <h1 className="font-medium text-[13px] leading-[19px] tracking-[2%] text-[#00000066]">
                    {decodeURIComponent(
                      isEdit.FileUrl.split("/")
                        .pop()
                        .split("-")
                        .slice(1)
                        .join("-")
                    )}
                  </h1>
                ) : (
                  <>
                    <h1 className="font-medium text-[13px] leading-[19px] tracking-[2%]">
                      <span className="text-[#CD2224]">
                        Click here Or Drag and Drop
                      </span>{" "}
                      to upload your file
                    </h1>
                    <h1 className="font-medium text-[13px] leading-[19px] text-center text-[#00000066]">
                      Supported Format: PDF (3MB each)
                    </h1>
                  </>
                )}
              </div>

              <input
                id="fileInput"
                type="file"
                className="hidden"
                accept=".pdf"
                onChange={(e) => handleFileChange(e)}
              />
            </div>
            {fileError && <p className="text-red-500 text-sm">{fileError}</p>}
          </div>

          {/* Form Section */}
          <form className="flex flex-col gap-7 max-w-[512px] w-full">
            {/* State Select */}
            <InputField
              className="text-black placeholder:text-[#00000066]"
              label="State"
              placeholder="Select State"
              type="select"
              value={selectedState}
              options={states}
              onChange={(e) => {
                const selected = states.find((s) => s.State === e.target.value);
                setSelectedStateId(selected.StateId);
                setSelectedState(selected.State);
                setIsFormChanged(true);
              }}
            />

            {/* Acts/Rules Select */}
            <div className="flex flex-col gap-2">
              <label className="font-semibold text-[13px] leading-[19px] tracking-[0.268px] text-black">
                Act/Rule <span className="text-red-600 text-xl">*</span>
              </label>

              <div className="flex flex-col gap-2 ">
                {/* Acts Option */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="actRule"
                    value="Acts"
                    checked={type === "Acts"}
                    onChange={(e) => {
                      setType(e.target.value);
                      setIsFormChanged(true);
                    }}
                    className="accent-[#CD2224] w-4 h-4"
                  />
                  <span className="text-sm text-gray-800">Acts</span>
                </label>

                {/* Rules Option */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="actRule"
                    value="Rules"
                    checked={type === "Rules"}
                    onChange={(e) => {
                      setType(e.target.value);
                      setIsFormChanged(true);
                    }}
                    className="accent-[#CD2224] w-4 h-4"
                  />
                  <span className="text-sm text-gray-800">Rules</span>
                </label>
              </div>
            </div>

            {/* File Name Textarea */}
            <div>
              <InputField
                label="Act/Rule Name"
                placeholder="Enter Act/Rule Name"
                type="textarea"
                value={title}
                onChange={handleTextArea}
              />
              {nameError && (
                <span className="text-red-500 text-sm">{nameError}</span>
              )}
            </div>
          </form>
        </div>

        {/* Buttons */}
        <div className="flex justify-center items-center gap-6">
          <button
            onClick={handleSubmit}
            disabled={isButtonDisabled || (isEdit && !isFormChanged)}
            className={`flex items-center gap-1 lg:px-6 lg:py-3 bg-[#CD2224] hover:bg-black transition duration-200 rounded-2xl text-white text-sm leading-5 tracking-[2%]
    ${
      isButtonDisabled || (isEdit && !isFormChanged)
        ? "opacity-50 cursor-not-allowed"
        : ""
    }
  `}
          >
            {!isEdit ? "Upload" : "Update"}
          </button>

          <button
            onClick={onClose}
            className="flex items-center gap-1 lg:px-6 lg:py-3 bg-[#F5E0DF] hover:bg-black hover:text-white transition duration-200 rounded-2xl text-[#CD2224] text-sm leading-5 tracking-[2%]"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadActsRules;
